import { useEffect } from "react";

/** Tarayıcı, arama girdisini kayıtlı kullanıcı adıyla doldurabiliyor (Chrome ve
 *  Firefox). Kontrollü girdide React durumu değişmediği için değer ekranda
 *  kalıp yanlış filtrelemeye yol açıyordu. Bu kanca, mount'tan sonra DOM
 *  değerini React durumuyla senkronlar: durum boşsa DOM da boşaltılır. */
export const useAutofillGuard = (ref, value) => {
  useEffect(() => {
    const sync = () => {
      const el = ref.current;
      if (el && el.value !== value) el.value = value ?? "";
    };
    sync();
    const t1 = setTimeout(sync, 150);
    const t2 = setTimeout(sync, 700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAutofillGuard;
